export default __webpack_public_path__ + "assets/Bandera-USA.f7846c86d7d96ceda2ee00dfa1181686.svg";